import { render } from "./DCheckbox.vue?vue&type=template&id=28657d96&scoped=true"
import script from "./DCheckbox.vue?vue&type=script&lang=js"
export * from "./DCheckbox.vue?vue&type=script&lang=js"

import "./DCheckbox.vue?vue&type=style&index=0&id=28657d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28657d96"]])

export default __exports__